module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/HowToCompareSection/compare-264ee96a4b6f737817c0d73fa88e4718.png";